/* tslint:disable */
import {
  App,
  Tenant,
  Entity,
  Entityrecordhistory,
  GeoPoint
} from '../index';

declare var Object: any;
export interface EntityrecordInterface {
  data: any;
  geopoint?: GeoPoint;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  appId?: any;
  tenantId?: any;
  entityId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
  tenant?: Tenant;
  entity?: Entity;
  entityrecordhistory?: Entityrecordhistory[];
}

export class Entityrecord implements EntityrecordInterface {
  data: any;
  geopoint: GeoPoint;
  lastupdatedby: string;
  createdby: string;
  id: any;
  appId: any;
  tenantId: any;
  entityId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  tenant: Tenant;
  entity: Entity;
  entityrecordhistory: Entityrecordhistory[];
  constructor(data?: EntityrecordInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entityrecord`.
   */
  public static getModelName() {
    return "Entityrecord";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entityrecord for dynamic purposes.
  **/
  public static factory(data: EntityrecordInterface): Entityrecord{
    return new Entityrecord(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entityrecord',
      plural: 'entityrecords',
      properties: {
        data: {
          name: 'data',
          type: 'any'
        },
        geopoint: {
          name: 'geopoint',
          type: 'GeoPoint'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        tenant: {
          name: 'tenant',
          type: 'Tenant',
          model: 'Tenant'
        },
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        entityrecordhistory: {
          name: 'entityrecordhistory',
          type: 'Entityrecordhistory[]',
          model: 'Entityrecordhistory'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entityrecord.ts